module.exports = __webpack_public_path__ + "static/media/oberflex-chenet3-1200x2490.dc83b9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-chenet3-1200x2490.jpg
// module id = 990
// module chunks = 37